import { render, staticRenderFns } from "./MiniProfile.vue?vue&type=template&id=dbbc67ee&scoped=true&"
import script from "./MiniProfile.vue?vue&type=script&lang=js&"
export * from "./MiniProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbbc67ee",
  null
  
)

export default component.exports